import $ from 'jquery';

(function() { // Begin scoping function

  const occasionCarousel = $('.panel-occasion-carousel-carousel');
  const offset = 50;
  let transitioning = false;

  // A $( document ).ready() block.
  $(document).ready(() => {

    setOccasionCarouselSlidePosition(1);

    $('.panel-occasion-carousel-thumbnail').click(function() {
      const position = $(this).data('position');
      setOccasionCarouselSlidePosition(position);
    });

    occasionCarousel.on('touchstart', function(event) {
      const xClick = event.originalEvent.touches[0].pageX;
      $(this).one('touchmove', (event) => {
        const xMove = event.originalEvent.touches[0].pageX;
        if (Math.floor(xClick - xMove) > 5) {
          occasionCarouselNextSlide();
        } else if (Math.floor(xClick - xMove) < -5) {
          occasionCarouselPreviousSlide();
        }
      });
      occasionCarousel.on('touchend', function() {
        $(this).off('touchmove');
      });
    });
  });

  function setOccasionCarouselSlidePosition(position = 1) {

    if (transitioning) {

    } else {
      transitioning = true;

      const occasionContents = $('.panel-occasion-carousel-occasion-content');
      const occasionImageOne = $('.panel-occasion-carousel-image-1');
      const occasionImageTwo = $('.panel-occasion-carousel-image-2');

      occasionContents.each(function(index) {
        $(this).css('opacity', 0);
        $(this).css('left', `${-1 * offset}px`);
        $(this).css('right', `${offset}px`);
        if ($(this).data('position') == position) {
          $(this).animate({
            opacity: 1,
            left: '0',
            right: '0',
          }, 1000, () => {

          });
        }
      });

      occasionImageOne.each(function(index) {
        $(this).css('opacity', 0);
        $(this).css('right', `${-1 * offset}px`);
        if ($(this).data('position') == position) {
          $(this).animate({
            opacity: 1,
            right: '0',
          }, 1000, () => {

          });
        }
      });

      occasionImageTwo.each(function(index) {
        $(this).css('opacity', 0);
        $(this).css('bottom', `${offset}px`);
        if ($(this).data('position') == position) {
          $(this).animate({
            opacity: 1,
            bottom: '0',
          }, 1000, () => {
            transitioning = false;
          });
        }
      });

      $('.panel-occasion-carousel-thumbnail').removeClass('panel-occasion-carousel-thumbnail-selected');
      $(`.panel-occasion-carousel-thumbnail[data-position='${position}']`).addClass('panel-occasion-carousel-thumbnail-selected');
    }
  }

  function occasionCarouselNextSlide(rotate = false) {
    const selectedSlide = occasionCarousel.find('.panel-occasion-carousel-thumbnail-selected').data('position');
    const numberOfSlides = occasionCarousel.find('.panel-occasion-carousel-occasion-content').length;
    if ((selectedSlide == numberOfSlides) & rotate) {
      setOccasionCarouselSlidePosition(1);
    } else if (selectedSlide != numberOfSlides) {
      setOccasionCarouselSlidePosition(selectedSlide + 1);
    }
  }

  function occasionCarouselPreviousSlide(rotate = false) {

    const selectedSlide = occasionCarousel.find('.panel-occasion-carousel-thumbnail-selected').data('position');
    const numberOfSlides = occasionCarousel.find('.panel-occasion-carousel-occasion-content').length;
    if ((selectedSlide == 1) & rotate) {
      setOccasionCarouselSlidePosition(numberOfSlides);
    } else if (selectedSlide != 1) {
      setOccasionCarouselSlidePosition(selectedSlide - 1);
    }
  }

})(); // End scoping function
